var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrowUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.17969L15 12.1797L13.8281 13.3516L10 9.52344L6.17188 13.3516L5 12.1797L10 7.17969Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrowUp);
export default __webpack_public_path__ + "static/media/SelectArrowUp.96884f467c7d1990543989261bdeb314.svg";
export { ForwardRef as ReactComponent };